export default __webpack_public_path__ + "images/25_2_image.jpg";